/**
 * Added to room and holds the age group
 */
class AgeGroupComponent {
    constructor(ageGroup) {
        this.typeId = AgeGroupComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.ageGroup = ageGroup;
    }
    eq(other) {
        return this.ageGroup === other.ageGroup;
    }
}
AgeGroupComponent.id = 2047;
export default AgeGroupComponent;
//# sourceMappingURL=AgeGroupComponent.js.map